import { render, staticRenderFns } from "./Adbox.vue?vue&type=template&id=25aeb03e&scoped=true"
import script from "./Adbox.vue?vue&type=script&lang=js"
export * from "./Adbox.vue?vue&type=script&lang=js"
import style0 from "./Adbox.vue?vue&type=style&index=0&id=25aeb03e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aeb03e",
  null
  
)

export default component.exports